import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LogoMark } from "@/components/Logo";
import { Hero } from "@/components/home/Hero";
import { Bento } from "@/components/home/Bento";
import { Process } from "@/components/home/Process";
import { FlapjackSpotlight } from "@/components/home/FlapjackSpotlight";
import { ChefBand, FinalCta, ResourcesBand } from "@/components/home/Bands";
import { Marquee } from "@/components/Marquee";

let introPlayed = false;

const Curtain = () => (
  <motion.div
    className="fixed inset-0 z-[100] grid place-items-center bg-[#141412]"
    exit={{ y: "-100%" }}
    transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
    data-testid="intro-curtain"
  >
    <div className="flex flex-col items-center gap-6">
      <LogoMark className="h-16 w-16" draw />
      <motion.img
        src="/images/culifect_logo_light.png"
        alt="Culifect Catering"
        initial={{ clipPath: "inset(0 100% 0 0)" }}
        animate={{ clipPath: "inset(0 0% 0 0)" }}
        transition={{ duration: 0.9, delay: 0.35, ease: [0.76, 0, 0.24, 1] }}
        className="h-14 w-auto sm:h-16"
      />
    </div>
  </motion.div>
);

export default function Home() {
  const [intro, setIntro] = useState(!introPlayed);
  const base = introPlayed ? 0 : 1.5;

  useEffect(() => {
    if (!intro) return undefined;
    const t = setTimeout(() => { introPlayed = true; setIntro(false); }, 1500);
    return () => clearTimeout(t);
  }, [intro]);

  return (
    <div data-testid="home-page">
      <AnimatePresence>{intro && <Curtain key="curtain" />}</AnimatePresence>
      <Hero base={base} />
      <Marquee dark />
      <Bento />
      <Process />
      <FlapjackSpotlight />
      <ChefBand />
      <Marquee />
      <ResourcesBand />
      <FinalCta />
    </div>
  );
}
